///-- THIS FILE IS GENERATED --///
export enum Resize {

    RESIZE_NONE = "pinata-resize-none",

    RESIZE_X = "pinata-resize-x",

    RESIZE_Y = "pinata-resize-y",

}